import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';

import FormSwitchery from 'components/forms/FormSwitchery';
import FormTags from 'components/forms/FormTags';

import ClientBillingSettings from 'components/layout/client/ClientBillingSettings';
import InvoicePaymentOption from 'components/layout/client/InvoicePaymentOption';
import UserSubscriptionPaidBy from 'components/layout/client/UserSubscriptionPaidBy';
import RemindPeriod from 'components/layout/client/RemindPeriod';
import ClientBudget from 'components/layout/client/ClientBudget';
import { ROLE_ADMIN, ROLE_COMPANY, ROLE_ROOT_EMPLOYEE, ROLE_SUPERADMIN } from 'js/constants';
import may from 'js/security';
import React, { StrictMode } from 'react';
import { Col, Row } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CompanyFilteredSubscription from 'components/layout/client/CompanyFilteredSubscription';

class ClientFinancial extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 0,
    };
  }

  updateEntity = (propertyName, value) => {
    const { entity, changeEntity } = this.props;
    const newEntity = { ...entity.updateValue(propertyName, value, ['financial']) };
    changeEntity(newEntity);
  };

  updateIdentEntity = (propertyName, value) => {
    const debtorNumber = propertyName === 'debtorNumber' && value && !Number.isNaN(Number(value)) ? parseInt(value, 10) : value;
    const { entity, changeEntity } = this.props;
    const newEntity = { ...entity.updateValue(propertyName, debtorNumber, ['ident']) };
    changeEntity(newEntity);
  };

  updateBankEntity = (propertyName, value) => {
    const { entity, changeEntity } = this.props;
    const newEntity = { ...entity.updateValue(propertyName, value, ['financial', 'bankData']) };
    changeEntity(newEntity);
  };

  updateEntityRoles = (name, value) => {
    const { entity, changeEntity } = this.props;
    let roleArray = entity.data.roles;

    if (value === true) {
      roleArray = ['ROLE_COMPANY', 'ROLE_USER', 'ROLE_VENDOR'];
    } else {
      const index = entity.data.roles.indexOf('ROLE_VENDOR', 0);
      const sliced = roleArray.slice(0, index);
      let sliced2 = [];
      if (index < roleArray.length - 1) {
        sliced2 = roleArray.slice(index + 1);
      }
      roleArray = [...sliced, ...sliced2];
    }

    const newEntity = { ...entity.updateValue(name, roleArray) };
    changeEntity(newEntity);
  };

  setActiveTab = index => {
    this.setState({ activeTab: index });
  };

  getClassName = index => {
    const { activeTab } = this.state;
    return activeTab === index ? 'active' : '';
  };

  render() {
    const {
      intl: { messages },
      entityLoaded,
      entity,
      disabled,
      inModal,
      user,
      typeOfUser,
      type,
      isVendor,
      changeEntity,
    } = this.props;

    const { activeTab } = this.state;
    const financial = entityLoaded && entity.getFinancial();
    const bankData = entityLoaded && financial.getBankData();
    const ident = entityLoaded && entity.getIdent();
    const debtorNumber = ident?.debtorNumber ?? '';
    return (
      <div className="clearfix">
        {entityLoaded && (
          <>
            <Row className="menu-clients">
              <Col xs={12} md={inModal ? 4 : 4}>
                <div className={`menu-button ${this.getClassName(0)}`} onClick={() => this.setActiveTab(0)}>
                  <h4 className="form-group-title">{messages.formGroup.basic_information}</h4>
                </div>
                <div className={`menu-button ${this.getClassName(1)}`} onClick={() => this.setActiveTab(1)}>
                  <h4 className="form-group-title">{messages.formGroup.bank_account}</h4>
                </div>
                <div className={`menu-button ${this.getClassName(2)}`} onClick={() => this.setActiveTab(2)}>
                  <h4 className="form-group-title">{messages.billing_settings}</h4>
                </div>
                <div className={`menu-button ${this.getClassName(3)}`} onClick={() => this.setActiveTab(3)}>
                  <h4 className="form-group-title">{messages.formGroup.company_information}</h4>
                </div>
                <div className={`menu-button ${this.getClassName(4)}`} onClick={() => this.setActiveTab(4)}>
                  <h4 className="form-group-title">{messages.settings}</h4>
                </div>
                {may(ROLE_COMPANY, entity.getRoles()) &&
                  (may(ROLE_ROOT_EMPLOYEE, user.roles) || may(ROLE_SUPERADMIN, user.roles)) && (
                    <div className={`menu-button ${this.getClassName(5)}`} onClick={() => this.setActiveTab(5)}>
                      <h4 className="form-group-title">{messages.filtered_subscriptions}</h4>
                    </div>
                  )}
              </Col>

              <Col xs={12} md={inModal ? 8 : 8}>
                {activeTab === 0 && (
                  <div className="active-content">
                    <h4>{messages.formGroup.basic_information}</h4>
                    <div className="form-group-attached">
                      <FormInput
                        label={messages.bookingAccountNumber}
                        name="bookingAccountNumber"
                        value={financial.getBookingAccountNumber()}
                        meta={financial.getBookingAccountNumberMetaInformation()}
                        validation={financial.getBookingAccountNumberValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.costAccountNumber}
                        name="costAccountNumber"
                        value={financial.getCostAccountNumber()}
                        meta={financial.getCostAccountNumberMetaInformation()}
                        validation={financial.getCostAccountNumberValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <div className="form-group form-group-default padding-10">
                        <FormSwitchery
                          label={messages.is_debtor}
                          name="isDebtor"
                          checked={financial.getIsDebtor()}
                          value
                          onChange={this.updateEntity}
                          disabled={disabled}
                        />
                      </div>
                      <FormInput
                        label={messages.debtor_number}
                        name="debtorNumber"
                        value={debtorNumber}
                        onChange={this.updateIdentEntity}
                        disabled={disabled || !financial.getIsDebtor()}
                        type="number"
                      />
                      <FormInput
                        label={messages.alt_debtor_number}
                        name="altDebtorNumber"
                        value={financial.getAltDebtorNumber()}
                        onChange={this.updateEntity}
                        disabled={disabled || !financial.getIsDebtor()}
                      />

                      {financial.getIsDebtor() && (
                        <div className="form-group form-group-default padding-10">
                          <FormSwitchery
                            label={messages.is_vendor}
                            name="roles"
                            checked={isVendor}
                            value
                            onChange={this.updateEntityRoles}
                            disabled={disabled}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {activeTab === 1 && (
                  <div className="active-content">
                    <h4>{messages.formGroup.bank_account}/SEPA</h4>
                    <h4 className="m-t-10">{messages.formGroup.bank_account}</h4>
                    <div className="form-group-attached">
                      <FormInput
                        label={messages.bank_name}
                        name="bankName"
                        value={bankData.getBankName()}
                        meta={bankData.getBankNameMetaInformation()}
                        validation={bankData.getBankNameValidationResult()}
                        onChange={this.updateBankEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.account_holder}
                        name="accountHolder"
                        value={bankData.getAccountHolder()}
                        meta={bankData.getAccountHolderMetaInformation()}
                        validation={bankData.getAccountHolderValidationResult()}
                        onChange={this.updateBankEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.account_number}
                        name="accountNumber"
                        value={bankData.getAccountNumber()}
                        meta={bankData.getAccountNumberMetaInformation()}
                        validation={bankData.getAccountNumberValidationResult()}
                        onChange={this.updateBankEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.bank_location}
                        name="bankLocation"
                        value={bankData.getBankLocation()}
                        meta={bankData.getBankLocationMetaInformation()}
                        validation={bankData.getBankLocationValidationResult()}
                        onChange={this.updateBankEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.bank_code_number}
                        name="bankCodeNumber"
                        value={bankData.getBankCodeNumber()}
                        meta={bankData.getBankCodeNumberMetaInformation()}
                        validation={bankData.getBankCodeNumberValidationResult()}
                        onChange={this.updateBankEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.iban}
                        name="iban"
                        value={bankData.getIban()}
                        meta={bankData.getIbanMetaInformation()}
                        validation={bankData.getIbanValidationResult()}
                        onChange={this.updateBankEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.swift_bic}
                        name="swiftBic"
                        value={bankData.getSwiftBic()}
                        meta={bankData.getSwiftBicMetaInformation()}
                        validation={bankData.getSwiftBicValidationResult()}
                        onChange={this.updateBankEntity}
                        disabled={disabled}
                      />
                    </div>

                    <h4>SEPA</h4>
                    <div className="form-group-attached">
                      <FormInput
                        label={'SEPA ' + messages.creditor_id}
                        name="creditorId"
                        value={financial.getCreditorId()}
                        meta={financial.getCreditorIdMetaInformation()}
                        validation={financial.getCreditorIdValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                )}
                {activeTab === 2 && (
                  <div className="active-content">
                    <h4>{messages.billing_settings}</h4>
                    {may(ROLE_ROOT_EMPLOYEE, user.roles) && (
                      <ClientBillingSettings
                        inModal={inModal}
                        clientId={entity.getUsername()}
                        entity={financial}
                        updateEntity={this.updateEntity}
                        disabled={disabled}
                      />
                    )}
                    {may(ROLE_ROOT_EMPLOYEE, user.roles) && (
                      <StrictMode>
                        <InvoicePaymentOption
                          inModal={inModal}
                          entity={entity}
                          changeEntity={changeEntity}
                          disabled={disabled}
                        />
                        <RemindPeriod
                          inModal={inModal}
                          entity={entity}
                          changeEntity={changeEntity}
                          disabled={disabled}
                        />
                      </StrictMode>
                    )}
                    {may(ROLE_COMPANY, entity.getRoles()) &&
                      (may(ROLE_ROOT_EMPLOYEE, user.roles) || may(ROLE_SUPERADMIN, user.roles)) && (
                        <StrictMode>
                          <UserSubscriptionPaidBy
                            inModal={inModal}
                            entity={entity}
                            changeEntity={changeEntity}
                            disabled={disabled}
                          />
                        </StrictMode>
                      )}
                    {entityLoaded &&
                      entity.getType() !== 'customer' &&
                      typeOfUser !== 'customer' &&
                      may(ROLE_ADMIN, user.roles) &&
                      type !== 'new' && (
                        <ClientBudget
                          inModal={inModal}
                          clientId={entity.getUsername()}
                          entity={financial}
                          updateEntity={this.updateEntity}
                          disabled={disabled}
                        />
                      )}
                  </div>
                )}
                {activeTab === 3 && (
                  <div className="active-content">
                    <h4>{messages.formGroup.company_information}</h4>
                    <h4>{messages.salesDoc.register_and_taxes}</h4>
                    <div className="form-group-attached">
                      <FormInput
                        label={messages.vat_id}
                        name="vatId"
                        value={financial.getVatId()}
                        meta={financial.getVatIdMetaInformation()}
                        validation={financial.getVatIdValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.coc_number}
                        name="cocNumber"
                        value={financial.getCocNumber()}
                        meta={financial.getCocNumberMetaInformation()}
                        validation={financial.getCocNumberValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.registered_at}
                        name="registeredAt"
                        value={financial.getRegisteredAt()}
                        meta={financial.getRegisteredAtMetaInformation()}
                        validation={financial.getRegisteredAtValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                )}
                {activeTab === 4 && (
                  <div className="active-content">
                    <h4>{messages.other_settings}</h4>
                    <h4>{messages.currency_and_vat}</h4>
                    <div className="form-group-attached">
                      <FormAutocomplete
                        label={messages.currency}
                        name="currency"
                        value={financial.getCurrency()}
                        meta={financial.getCurrencyMetaInformation()}
                        validation={financial.getCurrencyValidationResult()}
                        onChange={this.updateEntity}
                        autocompleteType="currency"
                        complete
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.vat_name}
                        name="vatName"
                        value={financial.getVatName()}
                        meta={financial.getVatNameMetaInformation()}
                        validation={financial.getVatNameValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.vat_id_name}
                        name="vatIdName"
                        value={financial.getVatIdName()}
                        meta={financial.getVatIdNameMetaInformation()}
                        validation={financial.getVatIdNameValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormTags
                        label={messages.vat_rates}
                        name="vatRates"
                        value={financial.getVatRates()}
                        meta={financial.getVatRatesMetaInformation()}
                        validation={financial.getVatRatesValidationResult()}
                        onChange={this.updateEntity}
                        messages={messages}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                )}
                {activeTab === 5 && (
                  <div className="active-content">
                    <h4>{messages.filtered_subscriptions}</h4>
                    <h5 style={{ marginLeft: '10px' }}>{messages.filtered_subscriptions_description}</h5>
                    <div className="form-group-attached">
                      {may(ROLE_COMPANY, entity.getRoles()) &&
                        (may(ROLE_ROOT_EMPLOYEE, user.roles) || may(ROLE_SUPERADMIN, user.roles)) && (
                          <StrictMode>
                            <CompanyFilteredSubscription
                              inModal={inModal}
                              entity={entity}
                              changeEntity={changeEntity}
                              disabled={disabled}
                            />
                          </StrictMode>
                        )}
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </>
        )}
      </div>
    );
  }
}
ClientFinancial.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(ClientFinancial));
